import { toggleScroll } from '@/utils/scrollControl.js';

// Simple debouncer to throttle auth refresh after modal close
let refreshTimer = null;
function scheduleAuthRefresh(dispatch) {
  try { if (refreshTimer) clearTimeout(refreshTimer); } catch {}
  refreshTimer = setTimeout(() => {
    try { dispatch('getMe'); } catch {}
  }, 400); // small delay to ensure UI is stable after close
}

export default {
  showModal({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setShowModal', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  showOrgModal({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setOrgShowModal', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  showModalDraft({ commit }, value) {
    commit('setShowModalDraft', value);
  },
  showModalAboutUs({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setShowModalAboutUs', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  showModalReply({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setShowModalReply', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  addModalDataToState({ commit }, payload) {
    commit('setModalData', payload);
  },
  setReplyData({ commit }, data) {
    commit('setReplyPostData', data);
  },
  setQuoteData({ commit }, data) {
    commit('setQuotePostData', data);
  },
};
